<template>
	<div class="recruit_page">
		<!-- ヘッダー -->
		<headerBar></headerBar>
		<div class="image_area" :style="{'background-image':'url(' + bgimage + ')'}"></div>
		<!-- コンテンツ -->
		<div class="slogan_area">
			<div class="slogan">共に夢を追いかけよう</div>
		</div>
		<div class="contents_area">
			<div class="comment_area">
				当社では革新的でかつ信頼度の高い技術を使ったシステム開発や、お客様の要望にお答えする為のエンジニアを募集しています。<br>
				当社は生まれて間もない企業ですので、一緒に会社を盛り上げていける仲間を募集しています。
			</div>
			<div class="recruit_info">
				<div class="title">募集要項</div>
				<div class="recruit_area">
					<div class="recruit_table tbl">
						<div class="tblrow">
							<div class="fieldName tblcell">業務内容</div>
							<div class="field tblcell">ソフトウェア、Webアプリケーション、基幹業務システムの開発及び保守など</div>
						</div>
						<div class="tblrow">
							<div class="fieldName tblcell">応募資格</div>
							<div class="field tblcell">年齢不問<br>実務経験をお持ちの方歓迎</div>
						</div>
						<div class="tblrow">
							<div class="fieldName tblcell">勤務地</div>
							<div class="field tblcell">福岡県北九州市小倉北区浅野三丁目8-1 AIMビル 6F<br><span style="font-size:0.9rem">　※プロジェクトにより異なる場合があります</span></div>
						</div>
						<div class="tblrow">
							<div class="fieldName tblcell">勤務時間</div>
							<div class="field tblcell">9:00 〜 18:00<br><span style="font-size:0.9rem">　※プロジェクトにより異なる場合があります</span></div>
						</div>
						<div class="tblrow">
							<div class="fieldName tblcell">給与</div>
							<div class="field tblcell">月給16〜37万円（賞与年２回有り）</div>
						</div>
						<div class="tblrow">
							<div class="fieldName tblcell">休日</div>
							<div class="field tblcell">完全週休２日制（土・日）／ 祝日、夏季、年末年始、有給</div>
						</div>
						<div class="tblrow">
							<div class="fieldName tblcell">保険</div>
							<div class="field tblcell">雇用保険、労災保険、社会保険、厚生年金</div>
						</div>
					</div>
				</div>
			</div>
			<div class="recruit_contact">
				<div class="title">募集方法</div>
				<div class="contact_info">
					<div class="subtitle">○ハローワークからエントリー</div>
					<div class="comment">
						最寄りのハローワークよりエントリーして下さい。<br>
						<span style="font-size:0.9rem">※ハローワークへ掲載されていない場合もあります。</span>
					</div>
					<div class="subtitle" style="margin-top:20px">○郵送による応募</div>
					<div class="comment">
						履歴書（写真貼付）、職務経歴書等を弊社宛に郵送して下さい。<br>
						<div class="address">
							〒802-0001<br>
							福岡県北九州市小倉北区浅野三丁目8-1 AIMビル6F COMPASS小倉
						</div>
						書類審査後、改めて担当よりご連絡させて頂きます。
					</div>
					<div class="caution">
						※採用に関しては「<router-link :to="{ path:'/contact' }">お問い合わせ</router-link>」からお問い合わせ頂けます。
					</div>
				</div>
			</div>
		</div>
		<!-- サイトマップ -->
		<sitemap></sitemap>
	</div>
</template>

<script>
import Vue from 'vue'
import headerBar from '@/components/headerBar.vue'
import sitemap from '@/components/map.vue'
export default {
	name: 'recruitPage',
	components: {
		'headerBar': headerBar,
		'sitemap': sitemap
	},
	data() {
		return {
			bgimage: require("@/assets/images/topSlide/image03.jpg")
		}
	},
	beforeRouteEnter(to, from ,next) {
		next(vm => {
			if (to.hash.match(/^#/)) {
				let anc = to.hash.replace(/^#/, '');
				vm.$scrollTo("#" + anc);
			} else {
				vm.$scrollTo("#app");
			}
		});
	},
	afterEach(to, from) {
		
	},
	watch: {
		'$route': function(n, o) {
			if (n.hash.match(/^#/)) {
				let anc = n.hash.replace(/^#/, '');
				this.$scrollTo("#" + anc);
			} else {
				this.$scrollTo("#app");
			}
		}
	}
}
</script>

<style lang="less" scoped>
.recruit_page {
	.image_area {
		width: 100%;
		height: 280px;
		background-size: cover;
		background-position: center;
	}
	
	.slogan_area {
		padding: 60px 80px 20px 80px;
		background-color: white;
		
		.slogan {
			width: 100%;
			text-align: center;
			font-size: 1.7rem;
			font-weight: bold;
		}
	}
	
	.contents_area {
		padding: 60px 80px 20px 80px;
		
		.recruit_info {
			padding-top: 60px;
			
			.recruit_area {
				width: 100%;
				padding: 30px 40px 60px;
				
				.recruit_table {
					width: calc(100% - 80px);
					color: black;
					
					.fieldName, .field {
						padding: 16px 0;
						padding-left: 22px;
						padding-right: 22px;
					}
					
					.fieldName {
						width: 100px;
						text-align: center;
						white-space: nowrap;
						background-color: #e9e9e9;
						border-bottom: 1px solid #cecece;
					}
					
					.field {
						border-bottom: 1px solid #dcdcdc;
					}
					
					.tblrow {
						&:first-child .fieldName {
							border-top: 1px solid #cecece;
						}
						
						&:first-child .field {
							border-top: 1px solid #dcdcdc;
						}
					}
				}
			}
		}
		
		.recruit_contact {
			padding-bottom: 80px;
			
			.contact_info {
				margin-top: 20px;
				
				.subtitle {
					font-weight: bold;
					padding: 12px 22px;
				}
				
				.comment {
					padding: 0 22px 0 44px;
					
					.address {
						padding: 16px 22px;
					}
				}
				
				.caution {
					padding: 30px 22px;
				}
			}
			
			a {
				text-decoration: none;
				color: #6A6A6A;
				font-weight: bold;
			}
		}
	}
	
	.title {
		font-size: 1.1rem;
		font-weight: bold;
		border-left: 8px solid #eb5f1a;
		border-bottom: 1px solid #eb5f1a;
		padding-left: 6px;
		margin-bottom: 10px;
	}
}

@media(max-width:420px) {
	.recruit_page {
		.slogan_area {
			padding: 60px 28px 20px;
		}
		
		.contents_area {
			padding: 60px 28px;
			
			.recruit_info {
				.recruit_area {
					padding: 30px 0 60px;
					
					.recruit_table {
						width: 100%;
						
						.fieldName, .field {
							padding: 16px 0;
							padding-left: 12px;
							padding-right: 12px;
						}
						
						.fieldName {
							width: 40px;
						}
					}
				}
			}
			
			.recruit_contact {
				.contact_info {
					.comment {
						padding: 0 0 0 44px;
					}
				}
			}
		}
	}
}
</style>
